import {Accordion, KeyValueTable} from '@sdox/ui'

import type {XcNwBlock_VehicleDataTableSectionTypeBlockRowType_Fragment} from '@sdox/api'

export const BlockVehicleDataTable = (props: XcNwBlock_VehicleDataTableSectionTypeBlockRowType_Fragment) => {
  const items = props.items.map((item, idx) => (
    <Accordion
      title={item.title}
      key={idx}
    >
      <KeyValueTable
        data={item.items.map(row => ({
          label: row.key,
          data: row.value,
        }))}
      />
    </Accordion>
  ))

  return <div>{items}</div>
}
